import { startOfDay } from 'date-fns'

export const getUTCMidnightOfDay = date => {
  if (!date) return
  const localStartOfDay = startOfDay(date)
  localStartOfDay.setUTCHours(0, 0, 0, 0)
  return localStartOfDay
}
